import { useEffect, useState } from "react";
import TextInputField from "./TextInputField";
import useAuth from "../../hooks/useAuth";
import { FilledButton } from "./Button";
import { isEmail, validPassword } from "../../utils/regularExpressions";
import useGlobalLoading from "../../hooks/useGlobalLoading";
import useCurrentUser from "../../hooks/useCurrentUser";
import { IFreelancer } from "../../data_models/freelancer";
import useDisplayNotifications from "../../hooks/useDisplayNotifications";
import { useFilePicker } from "use-file-picker";
import { DisplayNotificationType } from "../../models/DisplayNotification";
import Avatar from "./Avatar";
import { RiImageAddLine } from "react-icons/ri";




interface UploadImageComponentProps {
    label?: string;
    type: 'profile-avatar';
    caption?: string;
}
const UploadImageComponent: React.FC<UploadImageComponentProps> = ({ label, type, caption }) => {

    const { openFilePicker, filesContent, plainFiles, loading } = useFilePicker({
        accept: ['image/*'], // Accept only image files
        multiple: false, // Allow only one file
    });
    const { setLoading } = useGlobalLoading();
    const { currentUser, updateProfilePicture } = useCurrentUser();
    const { addNotification } = useDisplayNotifications();


    useEffect(() => {
        // Handle the selected file after the file picker is closed
        if (filesContent.length > 0) {
            // const file = filesContent[0];
            const plain = plainFiles[0];

            switch (type) {
                case 'profile-avatar':
                    setLoading(true);
                    updateProfilePicture(plain).then((user) => {
                    }).catch((error: any) => {
                        addNotification(
                            {
                                message: error.message || 'An error occurred while updating the profile picture',
                                type: DisplayNotificationType.ERROR
                            },
                            true
                        )
                    }).finally(() => {
                        setLoading(false);
                    });
                    break;
                default:
                    break;
            }

        }
    }, [filesContent]);


    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
    }

    return (
        <div
            className="w-full cursor-pointer"
            onClick={openFilePicker}
        >
            {currentUser?.profilePictureUrl
                ? <div className="flex justify-center">
                    <Avatar
                        imageUrl={currentUser.profilePictureUrl}
                        onUpload={openFilePicker}
                    />
                </div>

                : <div>
                    {label && label.length > 0 &&
                        <p className="caption1">
                            {label}
                        </p>}
                    <div className="flex flex-col items-center space-y-6 py-4 border-dashed border-2 border-primary bg-neutral-100 rounded-2xl">
                        <RiImageAddLine className="w-14 h-14" />
                        <p>Choose image to upload</p>
                    </div>
                    {caption && caption.length > 0 &&
                        <p className="caption2 text-gray-400">
                            {caption}
                        </p>}
                </div>}
        </div>
    )
};

export default UploadImageComponent;